import { render, staticRenderFns } from "./ShoppingBagLogo.vue?vue&type=template&id=73b1922a&scoped=true&"
var script = {}
import style0 from "./ShoppingBagLogo.vue?vue&type=style&index=0&id=73b1922a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b1922a",
  null
  
)

export default component.exports